<div class="dasboard-width font-13">
    <div class="row header mar-lft-rgt-0">
        <div class="col-sm-4">Search</div>
        <!--        <div class="col-sm-3"> Organization - {{clientName}} <span><img src="../../assets/img/lnt_logo.jpg" height="40"-->
        <!--                                                                        width="60"></span></div>-->
        <div class="col-sm-4">
            <mat-form-field>
                <mat-label>Current Role:</mat-label>
                <mat-select [(ngModel)]="userGroupSelected" (selectionChange)="onSelectGroup()">
                    <mat-option *ngFor="let group of userGroups" [value]="group.groupId"
                    >{{group.grpName}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-4">
            <ol class="breadcrumb cust-bread">
                <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting()"><i
                        class="fa fa-dashboard"></i> Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">Search</li>
            </ol>
        </div>
    </div>
    <div class="row mar-lft-rgt-0 pad-top-5 filter filter-padding">
        <div class="col-sm-3">
            <mat-form-field>
                <mat-label>Ticket Type:</mat-label>
                <mat-select [(ngModel)]="ticketTypeSelected" (selectionChange)="onSelectTicketType($event.value)">
                    <mat-option *ngFor="let button of types; let i = index;" [value]="i"
                    >{{button.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field class="example-full-width">
                <input type="text" matInput [(ngModel)]="ticket_id"[formControl]="tikt_Id" placeholder="Ticket Id(Min. last 4 digits)"
                       autocomplete="off">
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field class = "position">
                <mat-label>Status:</mat-label>
                <mat-select [(ngModel)]="ticketStatusSelected" multiple>
                    <mat-option *ngFor="let status of allStatus" [value]="status.id"
                    >{{status.status}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <!--<div class="col-sm-3">-->
        <!--<mat-form-field>-->
        <!--<mat-label>Support Group:</mat-label>-->
        <!--<mat-select [(ngModel)]="supportGroupSelected">-->
        <!--<mat-option *ngFor="let group of userGroups" [value]="group.groupId"-->
        <!--&gt;{{group.grpName}}</mat-option>-->
        <!--</mat-select>-->
        <!--</mat-form-field>-->
        <!--</div>-->
        <div class="col-sm-3" [hidden]="isLabel0">
            <mat-form-field class = "position">
                <mat-label>Priority:</mat-label>
                <mat-select [(ngModel)]="prioritySelected"  multiple>
                    <mat-option *ngFor="let priority of priorities" [value]="priority.id"
                    >{{priority.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-3" [hidden]="isLabel0">
            <mat-form-field class = "position">
                <mat-label>Assignee:</mat-label>
                <mat-select [(ngModel)]="assigneeSelected" multiple>
                    <mat-option *ngFor="let user of assignee" [value]="user.id"
                    >{{user.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-3" [hidden]="isLabel0 || seq === 2">
            <mat-form-field class="example-full-width width">
                <input type="text" matInput [(ngModel)]="raised"class="form-control radius-0 font-13 search_login" 
                 placeholder="Raised by(Login ID OR Name)" [formControl]="searchUser"[matAutocomplete]="auto">
            </mat-form-field>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getUserDetails()">
                <mat-option *ngIf="isLoading" class="is-loading">
                    <mat-spinner diameter="50"></mat-spinner>
                </mat-option>
                <ng-container *ngIf="!isLoading">
                    <mat-option *ngFor="let user of userDtl" [value]="user.login_name"  class="matFont">
                      {{ user.name }} - {{user.login_name}}
                    </mat-option>
                </ng-container>
            </mat-autocomplete>
        </div>

    </div>
    <div class="row mar-lft-rgt-0 filter-padding">
        <div class="form-group col-sm-3">
            <!--[min]="minDate" [max]="maxDate"-->
            <input [owlDateTimeTrigger]="dt9" [owlDateTime]="dt9" class="form-control radius-0 font-13"
                   [(ngModel)]="fromDate" placeholder='Created Date From'>
            <owl-date-time [pickerType]="'calendar'" #dt9></owl-date-time>
        </div>
        <div class="form-group col-sm-3 mar-bot-10">
            <input [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10" class="form-control radius-0 font-13"
                   [(ngModel)]="toDate" placeholder='Created Date To'>
            <owl-date-time [pickerType]="'calendar'" #dt10></owl-date-time>
        </div>
    </div>

    <div class="row mar-lft-rgt-0 category filter-padding">
        <div class="col-md-12">
            <select class="custom-select  tcktyp" *ngFor="let ticket of allTicketTypes;"
                    (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}"
                    [disabled]="ticket.isDisabled">
                <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
            </select>
        </div>
    </div>

    <div class="row mar-lft-rgt-0 pad-top-5 seachbtn filter-padding">
        <button type="button" (click)="advanceSearch(paginationObj)" class="btn btn-primary search font-13 radius-0">
            Submit
        </button>
        <button type="button" (click)="resetSearch()" class="btn btn-primary search font-13 radius-0">Reset</button>
        <button type="button" (click)="exportToExcel()"  [disabled]="isExport" class="btn btn-primary search font-13 radius-0">Export To Excel</button>

        <div class="col-sm-2 mar-bot-10" [hidden]="ticketIdSearchLoaded">
            <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
    </div>

    <!--<span class="totalitem"><b>Total items: </b> {{totalItems}}</span>-->
    <div class="col-md-12 col-sm-12">
        <div class="card">
            <div class="card-header card-header-top">
                <div class="pull-right none font-13" [ngClass]="{'block':show}">(Selected
                    items:<span>{{selected}}</span>)
                </div>
                <div class="pull-right font-13">
                    <select class="custom-select mr-sm-2 radius-0 font-13 custom-width" [(ngModel)]="pageSizeSelected"
                            (change)="onPageSizeChange($event.target.selectedIndex)">
                        <option *ngFor="let pageSize of pageSizeObj" [value]="pageSize.id">{{pageSize.value}}</option>
                    </select>
                    <button class="btn btn-primary addButton" [disabled]="previousOffset === 0"
                            (click)="getPreviousData()"> <
                    </button>&nbsp;
                    <button class="btn btn-danger addButton" [disabled]="nextOffset === 0" (click)="getNextData()"> >
                    </button>&nbsp;
                    <span><b>Page</b> {{page_no}} <b>Of</b> {{totalPage}} &nbsp;&nbsp;<b>Total items: </b> {{totalData}}</span>
                </div>
            </div>
            <div class="card-body search-grid">
                <angular-slickgrid gridId="grid1"
                                   [columnDefinitions]="columnDefinitions"
                                   [gridOptions]="gridOptions"
                                   (onAngularGridCreated)="angularGridReady($event)"
                                   (sgOnCellChange)="onCellChanged($event.detail.eventData, $event.detail.args)"
                                   [gridHeight]="200"
                                   (sgOnSelectedRowsChanged)="handleSelectedRowsChanged($event.detail.eventData, $event.detail.args)"
                                   (sgOnClick)="onCellClicked($event.detail.eventData, $event.detail.args)"
                                   [dataset]="dataset">
                </angular-slickgrid>
            </div>
            <br/><br/>
        </div>
    </div>

    <!--================================-->
    <!--<div class="col-sm-12 height-250">-->
    <!--<angular-slickgrid gridId="grid1"-->
    <!--[columnDefinitions]="columnDefinitions"-->
    <!--[gridOptions]="gridOptions"-->
    <!--(onAngularGridCreated)="angularGridReady($event)"-->
    <!--(sgOnCellChange)="onCellChanged($event.detail.eventData, $event.detail.args)"-->
    <!--gridWidth="3200"-->
    <!--(sgOnSelectedRowsChanged)="handleSelectedRowsChanged($event.detail.eventData, $event.detail.args)"-->
    <!--(sgOnClick)="onCellClicked($event.detail.eventData, $event.detail.args)"-->
    <!--[dataset]="dataset">-->
    <!--</angular-slickgrid>-->
    <!--</div>-->
</div>
<div *ngIf="displayCr">
    <app-display-ticket-cr
            [typeChecked]="ticketTypeId" [clientId]="clientId" [userGroupId]="userGroupId"
            [groupName]="groupName"
            [grpLevel]="grpLevel" [notifier]="notifier"
            [seq]="seq" [inciId]="inciId"  [isSearch]="isSearch" (search)="ticketSearch()">
    </app-display-ticket-cr>
</div>
<div *ngIf="displayPr">
    <app-display-ticket-pr
            [typeChecked]="ticketTypeId" [clientId]="clientId" [userGroupId]="userGroupId"
            [groupName]="groupName"
            [grpLevel]="grpLevel" [notifier]="notifier"
            [seq]="seq" [inciId]="inciId"  [isSearch]="isSearch" (search)="ticketSearch()">
    </app-display-ticket-pr>
</div>
<div *ngIf="displayCit">
    <app-display-ticket-cit [typeChecked]="ticketTypeId" [clientId]="clientId" [userGroupId]="userGroupId"
                            [groupName]="groupName"
                            [grpLevel]="grpLevel" [notifier]="notifier"
                            [seq]="seq" [inciId]="inciId" [isSearch]="isSearch"
                            (search)="ticketSearch()"></app-display-ticket-cit>
    <notifier-container></notifier-container>
</div>
